/* --------------------------------------------------------------------------
	Sub Nav
-------------------------------------------------------------------------- */

	"use strict";
	var $ = jQuery;
	import "fastdom";
	import { MinLG } from "./page.js";
	import '../base/swap.js';

	var $SubNav,
		$SubNavBody,
	    $SubNavInner,
	    $SubNavList,
		$SubNavToggle,
		$PageHeaderInner,
		DisablePosition;

	function initSubNav() {
		$SubNavBody = $(".js-sub-nav-body");

		if (!$SubNavBody.length) {
			return;
		}

		$SubNav = $(".js-sub-nav");
		$SubNavInner = $(".js-sub-nav-body-inner");

		$SubNavList = $(".js-sub-nav-list");
		$SubNavList.attr("aria-hidden", "true")
		           .find("a").attr("tabindex", "-1");

		$SubNavToggle = $(".js-sub-nav-toggle");
		$SubNavToggle.attr("aria-expanded", "false")
		             .attr("aria-haspopup", "true")
		             .on("activate.swap", onSubSwapActivate)
					 .on("deactivate.swap", onSubSwapDeactivate);
					 
		$PageHeaderInner = $(".js-page-header-inner");

		DisablePosition = false;

		if( $("body").hasClass("page_theme_listing") ) {
			DisablePosition = true;
		}

		if($("body").hasClass("page_theme_child_page")){
			DisablePosition = true;
		}

		$(window).on('resize', onResize);
		onResize();
	}

	function onResize() {
		var height;
		var subnavActive;
		var window_width;
		var offset = 0;

		// This feature is cursed.
		//
		// Not Large Mode: There is an "Explore This
		// Section" button to expand the sub-nav. The animation is really
		// nav:after expanding and sliding up AND 
		// .js-sub-nav-body expanding. There is jank everywhere and crashes
		// older Safari versions.
		//
		// Should be <nav> expanding (not an :after and child, which removes all
		// this code), but haven't gotten it work.
		//
		// Large mode: When <h1> isn't overlapping a hero, move <nav>
		// up so the <h1> and <nav> start on the same row.

		fastdom.measure(function () {
			window_width = $(window).width();
			height = $SubNavInner.innerHeight();
			subnavActive = $SubNavToggle.hasClass("fs-swap-active");
			if (window_width >= MinLG && $PageHeaderInner.length > 0) {
				offset = $PageHeaderInner.height();
			}
		});

		fastdom.mutate(function () {
			if (subnavActive) {
				$SubNavBody.css("height", height);
			}
			if (window_width >= MinLG) {
				$SubNavBody.removeAttr("style");
			}

			if (DisablePosition) {
				return;
			}
			if( window_width >= MinLG ) {
				// This is noticable Content Layout Shift (CLS). Menu moves
				// up on DCL after page is visible.
				$SubNav.css("margin-top", "-" + offset + "px");
			} else {
				$SubNav.removeAttr("style");
			}
		});
	}

	function onSubSwapActivate() {
		$(this).attr("aria-expanded", "true");

		$SubNavList.attr("aria-hidden", "false")
		           .find("a").removeAttr("tabindex");

		var subNavHeight = null;
		fastdom.measure(function () {
			subNavHeight = $SubNavInner.innerHeight();
		});

		fastdom.mutate(function () {
			$SubNavBody.css("height", subNavHeight);
			$SubNav.addClass("open");
		});
	}

	function onSubSwapDeactivate() {
		$(this).attr("aria-expanded", "false");

		$SubNavList.attr("aria-hidden", "true")
		           .find("a").attr("tabindex", "-1");

		fastdom.mutate(function () {
			$SubNavBody.css("height", 0);
			$SubNav.removeClass("open");
		});
	}

	$(initSubNav);
